function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import ProgressIndicator from '../progressIndicator/ProgressIndicator';
import { SHAPE_CIRCULAR, SIZE_SMALL_THIN, STYLE_GRADIENT } from '../progressIndicator/constants';
import { IMAGE_LOADER_STATUSES, VERTICAL_ALIGNMENTS_PROP_TYPE } from './constants';

var ExtraContent = function ExtraContent(_ref) {
  var children = _ref.children;
  var component = null;

  if (children) {
    component = React.createElement("div", {
      className: "eds-list-item__aside eds-list-item__extra-content eds-l-pad-right-4",
      "data-spec": "list-item-extra-content"
    }, children);
  }

  return component;
};

var ItemImage =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ItemImage, _PureComponent);

  function ItemImage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ItemImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ItemImage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      imageStatus: IMAGE_LOADER_STATUSES.LOADING_STATE
    });

    _defineProperty(_assertThisInitialized(_this), "_handleImageLoaded", function () {
      return _this.setState({
        imageStatus: IMAGE_LOADER_STATUSES.LOADED_STATE
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleImageError", function () {
      return _this.setState({
        imageStatus: IMAGE_LOADER_STATUSES.FAILED_STATE
      });
    });

    return _this;
  }

  _createClass(ItemImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          extraContent = _this$props.extraContent,
          imageAlt = _this$props.imageAlt,
          imageUrl = _this$props.imageUrl,
          isSquareImage = _this$props.isSquareImage,
          progressIndicator = _this$props.progressIndicator,
          verticalAlignment = _this$props.verticalAlignment;
      var itemImageComponent;
      var progressIndicatorComponent = null;
      var imageStatus = this.state.imageStatus;
      var className = classNames('eds-list-item', _defineProperty({}, "eds-list-item--align-".concat(verticalAlignment), verticalAlignment));
      var classNameGraphic = classNames('eds-list-item__aside', 'eds-list-item__graphic', {
        'eds-list-item__graphic--square': isSquareImage
      });
      var classNameImage = classNames({
        'eds-show': imageStatus === IMAGE_LOADER_STATUSES.LOADED_STATE || imageStatus === IMAGE_LOADER_STATUSES.FAILED_STATE,
        'eds-hide': imageStatus === IMAGE_LOADER_STATUSES.LOADING_STATE
      });

      if (progressIndicator) {
        /**
         * In the case of  the failed load, the progress indicator should be unrendered
         * and the img tag should should the alt image.
         */
        if (imageStatus === IMAGE_LOADER_STATUSES.LOADING_STATE) {
          progressIndicatorComponent = React.createElement("div", {
            className: "eds-list-item__graphic-indicator eds-l-mar-all-3"
          }, React.createElement(ProgressIndicator, {
            shape: SHAPE_CIRCULAR,
            size: SIZE_SMALL_THIN,
            style: STYLE_GRADIENT
          }));
        }

        itemImageComponent = React.createElement("img", {
          src: imageUrl,
          alt: imageAlt,
          className: classNameImage,
          onLoad: this._handleImageLoaded,
          onError: this._handleImageError,
          "data-spec": "list-item-graphic-image--progress-indicator-img"
        });
      } else {
        itemImageComponent = React.createElement("img", {
          src: imageUrl,
          alt: imageAlt,
          "data-spec": "list-item-graphic-image"
        });
      }

      return React.createElement("div", {
        className: className,
        "data-spec": "eds-list-item"
      }, React.createElement(ExtraContent, null, extraContent), React.createElement("span", {
        className: classNameGraphic,
        "data-spec": "list-item-graphic"
      }, progressIndicatorComponent, itemImageComponent), React.createElement("div", {
        className: "eds-list-item__contents",
        "data-spec": "eds-list-item-contents"
      }, children));
    }
  }]);

  return ItemImage;
}(PureComponent);

_defineProperty(ItemImage, "propTypes", {
  /**
   * Contents of icon list item
   */
  children: PropTypes.node.isRequired,

  /**
   * Generic content for the left side
   */
  extraContent: PropTypes.node,

  /**
   * Vertical alignment of children items
   */
  verticalAlignment: VERTICAL_ALIGNMENTS_PROP_TYPE,

  /**
   * URL of image to be displayed with list item content
   */
  imageUrl: PropTypes.string,

  /**
   * Alt text for image to be displayed with list item content
   */
  imageAlt: EBPropTypes.translation,

  /**
   * Optional square shape image - note you must pass in an imageUrl
   * for an image that is either 1:1 or wider than it is tall.
   */
  isSquareImage: PropTypes.bool,

  /**
   * Whether or not the item should use a progress indicator while the image is loading
   */
  progressIndicator: PropTypes.bool
});

_defineProperty(ItemImage, "defaultProps", {
  verticalAlignment: 'middle',
  progressIndicator: false,
  isSquareImage: false
});

export { ItemImage as default };